import React, {Component} from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import CloseBtn from '../../components/CloseBtn';
import InnerWrap from './Wrap';
import BackSound from '../../components/BackSound';
import * as routes from '../../const/routes';
import * as videos from '../../const/videos';
import { withUiContext } from '../../UiContext';
import MenuBtn from '../../components/MenuBtn';
import NavContent from '../../components/NavContent';
import { substations } from '../../const/substations';
import { products } from '../../const/projects';
import MapSection from '../../components/MapSection';
import MapLocation from '../../components/MapSection/MapLocation';

class Project extends Component {
    state = {
        intro:        this.props.ui.intro,
        // intro:        false,
        navContent:   false,
        thisLocation: null,
        thisProjects: null,
        popupData:    null,
        substationId: 2,
        popup:        {
            type:   null,
            opened: false,
            data:   null,
        },
    }

    toggleNav = () => {
        this.setState((prevState) => ({navContent: !prevState.navContent}));
    }

    onEnded = () => {
        this.setState({intro: false})
    }

    onClickHandlerForLocationPoint = (event, locationId) => {
        event.stopPropagation();
        event.preventDefault();

        this[ `playTransitionLocation${locationId}` ]();

        this.props.ui.setCurrentLocation(locationId);
    }

    loadingLocationData = () => {
        const { ui } = this.props;
        const { substationId } = this.state;
        const { currentLocation } = ui;
        const currentSubstations = substations.find((item) => item.id === substationId);
        const thisLocation = currentSubstations.products.find((item) => item.id === currentLocation) || null;
        const thisProjects = thisLocation !== null ? [ thisLocation ] : null;

        return {
            thisLocation,
            thisProjects,
        };
    }

    render() {
        const { intro, navContent, substationId } = this.state;
        const currentSubstations = substations.find((item) => item.id === substationId);
        const { thisLocation } = this.loadingLocationData();

        return (
            <InnerWrap
                title = { !intro && currentSubstations.name }
                video = { videos.podst110_bg }
                intro = {{
                    status: this.state.intro,
                    video: videos.podst110_main,
                    onEnded: this.onEnded,
                }}
            >
                <div className = 'hud__container-content'>
                    {!intro && (
                        <MenuBtn
                            className = { `animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}` }
                            onClick = { this.toggleNav }
                            onMouseEnter = { this.props.ui.playOverSound }
                        />
                    )}

                    <TransitionGroup className = 'menu-outer'>
                        {navContent && (
                            <CSSTransition
                                classNames = 'menu-transition'
                                timeout = { 300 }
                            >
                                <NavContent onClose = { this.toggleNav } />
                            </CSSTransition>
                        )}
                    </TransitionGroup>

                    { !intro && currentSubstations && thisLocation === null && (
                        <MapSection>
                            { currentSubstations.products && currentSubstations.products.map((item, index) => {
                                const { id, coordinates } = item;
                                const cart = products.find((key) => key.id === id);

                                return (
                                    <MapLocation
                                        className = 'hud-map__location-project'
                                        key = { index }
                                        label = { cart.short ? cart.short : cart.name }
                                        labelStyles = {{
                                            width:     300,
                                            textAlign: 'center',
                                            margin:    '0 0 50px -150px',
                                        }}
                                        link = { routes[ `PODST_110_${index + 1}` ] }
                                        pointerStyles = {{
                                            width:  '85px',
                                            height: '85px',
                                        }}
                                        style = {{left: coordinates.x, top: coordinates.y }}
                                    />
                                );
                            })}
                        </MapSection>
                    )}
                </div>

                <div className = 'hud__container-controls'>
                    {!intro && (
                        <BackSound navContent = { navContent } />
                    )}

                    <CloseBtn link = { routes.PODST } introStatus />
                </div>
            </InnerWrap>
        );
    }
}

export default withUiContext(Project);
